import { BiPlus, BiMinus } from 'react-icons/bi';
import classNames from 'classnames';
import type { RoomAndGuestCount, GuestCount } from '../../booking/meal-plan/types';
import testIds from './testIds';
import MinusCircle from '../Icons/MinusCircle';
import tailwindConfig from '../../../../tailwind.config';
import PlusCircle from '../Icons/PlusCircle';

export const getTotalChildCount = (count: GuestCount) =>
  count.seniorElementarySchoolChildCount +
  count.juniorElementarySchoolChildCount +
  count.infantWithMealAndFutonCount +
  count.infantWithMealCount +
  count.infantWithFutonCount +
  count.infantWithoutMealAndFutonCount;

export const getTotalInfantCount = (count: GuestCount) =>
  count.infantWithMealAndFutonCount +
  count.infantWithMealCount +
  count.infantWithFutonCount +
  count.infantWithoutMealAndFutonCount;

type Props = {
  count: RoomAndGuestCount;
  guestType: keyof RoomAndGuestCount;
  setCount: (operation: 'add' | 'remove', type: keyof RoomAndGuestCount) => void;
  roundedSearchBar?: boolean;
};

const ROOM_MIN = 1;
const ROOM_MAX = 8;
const ADULT_MIN = 1;
const CHILD_MIN = 0;
const ADULT_MAX = 10;
const CHILD_MAX = 6;

const isMinusButtonDisabled = (count: RoomAndGuestCount, guestType: keyof RoomAndGuestCount) => {
  if (guestType === 'roomCount') return count[guestType] === ROOM_MIN;
  if (guestType === 'adultCount') return count[guestType] === ADULT_MIN;

  return count[guestType] === CHILD_MIN;
};
const isPlusButtonDisabled = (count: RoomAndGuestCount, guestType: keyof RoomAndGuestCount) => {
  if (guestType === 'roomCount') return count[guestType] === ROOM_MAX;
  if (guestType === 'adultCount') return count[guestType] === ADULT_MAX;

  return count[guestType] === CHILD_MAX;
};

const Counter = ({ count, guestType, setCount, roundedSearchBar }: Props) => (
  <div className="flex items-center gap-6">
    <button
      data-testid={testIds.minusButton}
      type="button"
      disabled={isMinusButtonDisabled(count, guestType)}
      onClick={() => setCount('remove', guestType)}
    >
      {roundedSearchBar ? (
        <MinusCircle
          size={32}
          color={
            isMinusButtonDisabled(count, guestType)
              ? tailwindConfig.theme.colors.gray[300]
              : tailwindConfig.theme.colors.orange[700]
          }
        />
      ) : (
        <BiMinus
          size={20}
          className={isMinusButtonDisabled(count, guestType) ? 'text-gray-300' : 'text-orange-700'}
        />
      )}
    </button>
    <p
      data-testid={testIds.countText}
      className={classNames({
        'text-xl font-bold': roundedSearchBar,
      })}
    >
      {count[guestType]}
    </p>
    <button
      data-testid={testIds.plusButton}
      type="button"
      disabled={isPlusButtonDisabled(count, guestType)}
      onClick={() => setCount('add', guestType)}
    >
      {roundedSearchBar ? (
        <PlusCircle
          size={32}
          color={
            isPlusButtonDisabled(count, guestType)
              ? tailwindConfig.theme.colors.gray[300]
              : tailwindConfig.theme.colors.orange[700]
          }
        />
      ) : (
        <BiPlus
          size={20}
          className={isPlusButtonDisabled(count, guestType) ? 'text-gray-300' : 'text-orange-700'}
        />
      )}
    </button>
  </div>
);
export default Counter;
